export default "__VITE_ASSET__BfEWEegN__"